/* eslint-disable camelcase */
import React, { useEffect, useState, useRef } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Layout, Breadcrumb, Tag, Image, Upload } from 'antd';
import { makeStyles, MenuItem } from '@material-ui/core';
import PersonalInfo from './PersonalInfo';
import FlightDetail from './FlightDetail';
import Lawyer from './Lawyer';
import addButton from './Add.svg';
import {
  getClaimAction,
  updateClaimAction,
  generateDocumentAction,
  uploadClaimFileAction,
  removeClaimFileAction,
  onGeneratePowerOFAttorneyAction,
  downloadFilesAction
} from '../../actions/claimAction';
import NoxTable from '../../component/Table';
import InnerHeader from '../../component/InnerHeader';
import ArrowNextIcon from '../../asset/arrow-next.svg';
import Loader from '../../component/Loader/Loader';
import Copy from '../../component/Copy';
import CButton from '../../component/Button';
import formatDate from '../../helpers/formatDate';
import camelCaseToTitleCase from '../../helpers/camelCaseToTitleCase';
import { DefaultSelect } from '../../component/Select';
import Modal from '../../component/Modal/Modal';

const useStyles = makeStyles({
  AddMedia: {
    alignItems: 'center',
    background: '#F0F4FF',
    border: 'none',
    borderRadius: '10px',
    color: '#5564F8',
    cursor: 'pointer',
    display: 'flex',
    fontSize: '12px',
    height: '80px',
    justifyContent: 'center',
    userSelect: 'none'
  },
  content: {
    color: '#9BA0AD',
    cursor: 'pointer',
    fontFamily: 'Poppins',
    fontSize: '12px',
    marginRight: '16px',
    padding: '14px 16px '
  },
  contentActive: {
    background: '#F0F4FF',
    borderRadius: '10px',
    color: '#5564F8',
    cursor: 'pointer',
    fontFamily: 'Poppins',
    fontSize: '12px',
    marginRight: '15px',
    padding: '14px 16px '
  },
  contentWrapperDiv: {
    display: 'flex',
    flexDirection: 'row',
    padding: '65px 40px 0px 35px'
  },
  gridItem: {
    borderLeft: '1px solid #CAD8FF',
    maxWidth: '230px',
    padding: '0px 60px 0px 35px',
    textAlign: 'start'
  },
  p: {
    color: '#9BA0AD',
    fontFamily: 'Poppins',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    lineHeight: '100%'
  },
  pageHeader: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    padding: ' 35px 0px 0px 35px'
  },
  select: {
    '& .MuiSelect-root': {
      padding: '0px',
      textAlign: 'start'
    },
    borderRadius: '10px',
    marginLeft: '8px',
    maxHeight: '40px ',
    padding: '0px',
    width: '180px'
  },
  span: {
    fontFamily: 'Poppins',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500
  },
  uploadError: {
    cursor: 'not-allowed',
    opacity: '0.6'
  }
});

const ClaimDetail = () => {
  const { claimToken } = useParams();
  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();
  const currentProject = useSelector(({ project }) => project.currentProject);
  const selectedClaim = useSelector(({ claims }) => claims.selectedClaim);
  const files = useSelector(({ claims }) => claims.files);
  const isLoaded = useSelector(({ claims }) => claims.isClaimLoaded);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isUploadEnabled, setUploadEnabled] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedMediaType, setSelectedMediaType] = useState('');
  const [status, setStatus] = useState({});

  const inputFile = useRef(null);

  function itemRender(route, params, routes) {
    const last = routes.indexOf(route) === routes.length - 1;

    return last ? (
      <span>{route.breadcrumbName}</span>
    ) : (
      <span onClick={() => history.goBack()} style={{ cursor: 'pointer' }}>
        {route.breadcrumbName}
      </span>
    );
  }

  const onSaveHandler = () => {
    dispatch(updateClaimAction(status.key, () => dispatch(getClaimAction(claimToken))));
  };

  const onGenerateDocument = () => {
    dispatch(generateDocumentAction(selectedClaim._id));
  };

  const onGeneratePowerOFAttorney = () => {
    dispatch(onGeneratePowerOFAttorneyAction(selectedClaim._id));
  };

  const uploadRequest = async (data) => {
    setUploadEnabled(false);
    const formData = new FormData();
    formData.append('file', data.file, selectedMediaType);

    dispatch(
      uploadClaimFileAction(selectedClaim._id, selectedMediaType, formData, () =>
        dispatch(getClaimAction(claimToken))
      )
    );

    setSelectedMediaType('');
    setShowModal(false);
    data.onSuccess();
  };

  const onFileDelete = async () => {
    selectedRowKeys.forEach((index) => {
      const item = data[index];
      let fileKey;
      let fileId;
      if (item.fileKey === 'files') {
        fileKey = 'files';
        fileId = item.id;
      } else {
        fileKey = item.fileKey;
        fileId = false;
      }
      dispatch(
        removeClaimFileAction(selectedClaim._id, fileKey, fileId, () =>
          dispatch(getClaimAction(claimToken))
        )
      );
    });

    setSelectedRowKeys([]);
  };

  const uploadError = () => {
    console.error('error');
  };

  useEffect(() => {
    async function load() {
      dispatch(getClaimAction(claimToken));
    }

    if (currentProject) {
      load();
    }
  }, [dispatch, currentProject, claimToken, selectedMediaType]);

  if (!isLoaded) {
    return Loader;
  }

  const routes = [
    {
      breadcrumbName: 'Claims',
      path: '/claims'
    },
    {
      breadcrumbName: selectedClaim._id,
      path: `/claims/${claimToken}`
    }
  ];

  const filterList = [
    { key: 'inProgress', value: 'In Progress' },
    { key: 'inReview', value: 'In Review' },
    { key: 'assignedToLawyer', value: 'Assigned to Lawyer' },
    { key: 'assignedToManager', value: 'Assigned to Manager' },
    { key: 'acceptedByAirline', value: 'Accepted by Airline' },
    { key: 'approved', value: 'Approved' },
    { key: 'compensationPaid', value: 'Compensation paid' },
    { key: 'paidToPAX', value: 'Paid to PAX' },
    { key: 'commissionReceived', value: 'Commission Received' },
    { key: 'paidByAirline', value: 'Paid by Airline' },
    { key: 'sentToAirline', value: 'Sent to Airline' },
    { key: 'appealedInADR', value: 'Appealed in ADR' },
    { key: 'appealedInCourt', value: 'Appealed in Court' },
    { key: 'rejectedByAirline', value: 'Rejected by Airline' },
    { key: 'returnedToManager', value: 'Returned to Manager' },
    { key: 'declined', value: 'Declined' },
    { key: 'customerUnavailable', value: 'Customer Unavailable' },
    { key: 'lackOfInformation', value: 'Lack of Information' },
    { key: 'pending', value: 'Pending' }
  ];

  const mediaTitles = [
    'signatureFile',
    'claimFile',
    'powerOfAttorney1File',
    'powerOfAttorney2File',
    'powerOfAttorney3File',
    'files'
  ];

  const contents = ['Personal Information', 'Flight Detail', 'Lawyer'];

  const actions = [
    {
      onClick: onGenerateDocument,
      title: 'Generate Document',
      type: 'primary'
    },
    {
      onClick: onGeneratePowerOFAttorney,
      title: 'Generate Power Of Attorney',
      type: 'primary'
    },
    {
      onClick: onSaveHandler,
      title: 'Save',
      type: 'primary'
    }
  ];

  const columns = [
    {
      dataIndex: 'link',
      key: 'link',
      render: (link) => (
        <Image height={48} src={link} style={{ objectFit: 'contain' }} width={48} />
      ),
      title: () => {
        return <div>Preview</div>;
      }
    },
    {
      dataIndex: 'name',
      key: 'name',
      render: (name) => {
        return <Copy text={name} />;
      },
      sorter: (a, b) => a.name.localeCompare(b.name),
      title: 'Name'
    },
    {
      dataIndex: 'size',
      key: 'size',
      render: (size) => {
        return <Copy text={size} />;
      },
      sorter: (a, b) => new Date(a.size) - new Date(b.size),
      title: 'Size'
    },
    {
      dataIndex: 'file_type',
      key: 'file_type',
      render: (file_type) => {
        return <Copy text={file_type} />;
      },
      sorter: (a, b) => a.file_type.localeCompare(b.file_type),
      title: 'File Format'
    },
    {
      dataIndex: 'created',
      key: 'created',
      render: (created) => {
        return <Copy text={created} />;
      },
      sorter: (a, b) => new Date(a.created) - new Date(b.created),
      title: <div>Upload Date</div>
    },
    {
      key: 'edit',
      render: (data) => {
        return (
          <Tag
            onClick={() => {
              window.open(data.link, '_blank');
            }}
          >
            Open
          </Tag>
        );
      }
    }
  ];

  const tableActions = [
    {
      onClick: () => setShowModal(true),
      title: 'Add Media',
      type: 'primary'
    },
    {
      onClick: () => downloadFiles(),
      title: 'Save All',
      type: 'primary'
    }
  ];

  if (selectedRowKeys.length) {
    tableActions.unshift({
      onClick: onFileDelete,
      title: 'Delete',
      type: 'default'
    });
  }

  const mapToTable = () => {
    const data = [];

    if (!files || !files.length) {
      return data;
    }

    const filteredFiles = files.filter((file) => file);

    filteredFiles.forEach(({ created, url, _id, size, name, file_type, fileKey }, index) => {
      const finalDate = formatDate(created);
      const fileName = mediaTitles.find((filter) => filter.key === fileKey);
      data.push({
        created: finalDate,
        fileKey,
        file_type,
        id: _id,
        key: index,
        link: url,
        name: fileName?.value ?? name,
        size: `${(size / 1024).toFixed()} Mb`
      });
    });

    return data;
  };

  const data = mapToTable();

  const downloadFiles = async () => {
    const arrayOfIds = data.map((file) => {
      return file.id;
    });

    const claimName = `${selectedClaim.firstName || ''} ${selectedClaim.lastName || ''}`;

    dispatch(
      downloadFilesAction(selectedClaim._id, {
        fileIds: arrayOfIds,
        filename: `${claimName.toString().length > 1 ? claimName : selectedClaim._id}.zip`
      })
    );
  };

  const PageHeader = () => {
    const getDate = (date) => {
      const rowDate = new Date(date).toString().split('(')[0];
      return rowDate.substring(3, rowDate.length - 18);
    };
    const defaultStatus = filterList.find((filter) => filter.key === selectedClaim.claimStatus);

    return (
      <div className={classes.pageHeader}>
        <DefaultSelect
          menuStyles={{
            width: '175px'
          }}
          onSelect={(value) => {
            const selectedObj = filterList.filter((item) => item.value === value)[0];
            setStatus(selectedObj);
          }}
          selectStyles={{
            marginRight: '30px',
            width: '175px'
          }}
          value={status.value || defaultStatus.value}
        >
          {filterList.map((obj) => (
            <MenuItem key={obj.key} value={obj.value}>
              {obj.value}
            </MenuItem>
          ))}
        </DefaultSelect>
        <div className={classes.gridItem}>
          <span className={classes.span}>{getDate(selectedClaim.createdAt)}</span>
          <p className={classes.p}>Created</p>
        </div>
        <div className={classes.gridItem}>
          <span className={classes.span}>{getDate(selectedClaim.createdAt)}</span>
          <p className={classes.p}>Last Generated</p>
        </div>
        <div className={classes.gridItem}>
          <a className={classes.span} href="https://royce.biz">
            https://royce.biz
          </a>
          <p className={classes.p}>URL</p>
        </div>
      </div>
    );
  };

  const PageBody = () => {
    const [index, setIndex] = useState(0);
    return (
      <div
        style={{
          height: 'fit-content',
          marginBottom: '100px',
          minHeight: 'calc(100vh - 165px)'
        }}
      >
        <div className={classes.contentWrapperDiv}>
          {contents.map((content, i) => {
            return (
              <div
                key={i}
                className={i === index ? classes.contentActive : classes.content}
                onClick={() => setIndex(i)}
              >
                {content}
              </div>
            );
          })}
        </div>
        {pageContent(index)}
      </div>
    );
  };

  const pageContent = (index) => {
    switch (index) {
      case 0:
        return <PersonalInfo />;

      case 1:
        return <FlightDetail />;

      case 2:
        return <Lawyer />;

      default:
    }
  };

  return (
    <Layout
      style={{
        background: 'white'
      }}
    >
      <div style={{ marginTop: '40px', padding: '0px 40px 0px 35px' }}>
        <Breadcrumb
          itemRender={itemRender}
          routes={routes}
          separator={<img alt="separator icon" src={ArrowNextIcon} />}
          style={{
            background: 'white',
            display: 'flex',
            justifyContent: 'flex-start'
          }}
        />
      </div>
      <div
        style={{
          height: 'fit-content',
          marginBottom: '60px',
          marginTop: '60px',
          minHeight: 'calc(100vh - 165px)'
        }}
      >
        <InnerHeader
          actions={actions}
          copyId={selectedClaim._id}
          subtitle=""
          title={selectedClaim._id}
        />

        <PageHeader />
        <PageBody />
        <NoxTable
          actions={tableActions}
          columns={columns}
          data={data}
          searchBy="name"
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
        />
        <Modal
          footerActions={
            <>
              <CButton
                onClick={() => {
                  setShowModal(false);
                  setSelectedMediaType('');
                }}
                type="secondary"
              >
                Cancel
              </CButton>
              <Upload
                customRequest={uploadRequest}
                style={{ display: 'none', height: '1px', width: '1px' }}
              >
                <button ref={inputFile} style={{ display: 'none', height: '1px', width: '1px' }}>
                  Click to Upload
                </button>
              </Upload>
            </>
          }
          handleClose={() => {
            setShowModal(false);
            setSelectedMediaType('');
          }}
          isModalOpen={showModal}
          styles={{
            '& .MuiDialogContent-root': {
              display: 'flex',
              flexDirection: 'column',
              gap: '20px',
              paddingTop: '5px'
            },
            width: '400px'
          }}
          titleContent={<p className="modal-title">Feature</p>}
        >
          <DefaultSelect
            onSelect={(mediaTitle) => {
              setSelectedMediaType(mediaTitle);
              setUploadEnabled(true);
            }}
            value={selectedMediaType}
          >
            {mediaTitles.map((mediaType) => (
              <MenuItem key={mediaType} value={mediaType}>
                {camelCaseToTitleCase(mediaType)}
              </MenuItem>
            ))}
          </DefaultSelect>
          <div
            className={
              isUploadEnabled && selectedMediaType !== ''
                ? classes.AddMedia
                : `${classes.AddMedia} ${classes.uploadError}`
            }
            onClick={
              isUploadEnabled && selectedMediaType !== ''
                ? () => inputFile.current.click()
                : uploadError
            }
          >
            <img alt="add media" src={addButton} />
            Add Document
          </div>
        </Modal>
      </div>
    </Layout>
  );
};

export default ClaimDetail;
